import { css } from "@emotion/react";

import { CheckCircle } from "@livechat/design-system-icons";
import {
  Button,
  DesignToken,
  Heading,
  Icon,
  Modal,
  ModalHeader,
  SpacingToken,
  Text,
} from "@livechat/design-system-react-components";

import Flex from "components/layout/Flex";
import { isInIframe } from "helpers/app";
import { withVar } from "themes/helpers";

type Props = { onClose(): void; mode: "edit" | "add"; onSave(): void };

export const TemplatePublishModal: React.FC<Props> = ({ mode, onClose, onSave }) => {
  const isEmbeddedInIframe = isInIframe();

  const handleSave = (): void => {
    onSave();
    onClose();
  };

  return (
    <Modal
      css={css({ width: "600px" })}
      heading={<ModalHeader />}
      onClose={onClose}
      footer={
        <Flex justifyContent="center" width="100%" paddingBottom={withVar(SpacingToken.Spacing8)}>
          <Button size="large" kind="secondary" style={{ marginRight: "8px" }} onClick={onClose}>
            Back to editing
          </Button>
          <Button
            kind={isEmbeddedInIframe ? "high-contrast" : "primary"}
            size="large"
            onClick={handleSave}
            data-testid="save-template-modal-button"
          >
            {`${mode === "add" ? "Create" : "Update"} email template`}
          </Button>
        </Flex>
      }
    >
      <Flex column alignItems="center" gap={withVar(SpacingToken.Spacing2)}>
        <Icon
          size="xxxlarge"
          source={CheckCircle}
          customColor={withVar(DesignToken.ContentBasicDisabled)}
          css={{ marginBottom: withVar(SpacingToken.Spacing1) }}
        />
        <Heading css={css({ padding: `${withVar(SpacingToken.Spacing2)} 0` })}>
          {`${mode === "add" ? "Create" : "Update"} email template?`}
        </Heading>
        <Text textAlign="center" css={css({ paddingBottom: withVar(SpacingToken.Spacing6) })}>
          If you create an email template, it&apos;ll be published in the email templates list and used in the replying
          process by the specified team.
        </Text>
      </Flex>
    </Modal>
  );
};
